import { Avatar } from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import isoCountries from "i18n-iso-countries";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { ReactComponent as ImportHover } from "../../../src/assets/USA_Images/ImportHover.svg";
import { ReactComponent as ImportIcon } from "../../../src/assets/USA_Images/ImportIcon.svg";
import {
  REACT_INTEGRATION_ACCESS_LEVEL_LIST,
  REACT_INTEGRATION_CARD_HOLDER_LIST,
  REACT_INTEGRATION_LIST,
} from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import BulkEmployee from "../../components/DialogBoxComponent/BulkEmployee";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  deactivateEmployeeAccount,
  getEmployeeMappedIntegration,
  getIntegrationStatus,
  listAllEmployees,
  resendActivationLink,
} from "../../slices/Employee/EmployeeSlice";
import getMemberShipByUserId from "../../slices/MemberShipSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import GenetecAccessLevlIcon from "../Genetec/GenetecAccessLevlIcon";
import GenetecCardHolderIcon from "../Genetec/GenetecCardHolderIcon";
import ResendIcon from "../Invitations/ResendIcon";
import EditIcon from "../Person/EditIcon";
import CreateEmployee from "./CreateEmployee";
import DeleteEmployee from "./DeleteEmployee";
import EmployeeDeleteIcon from "./EmployeeDeleteIcon";
import EmployeeFilter from "./EmployeeFilter";

export default function Employee() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [clear, setClear] = useState(false);
  const [searchedRows, setSerchedRows] = useState([]);
  const { t } = useTranslation();
  const [employeeId, setEmployeeId] = useState();
  const [personFirstName, setPersonFirstName] = useState();
  const [openDeletePerson, setOpenDeletePerson] = useState(false);
  const [personUserId, setPersonUserId] = useState();
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const [roleId, setRoleId] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const history = useHistory();
  const [selectedObject, setSelectedObject] = useState({
    employee: {
      id: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneCountryCode: "",
      phone: "",
      gender: "",
      profilePhoto: "",
      departmentId: "",
      designationId: "",
      code: "",
      departmentIdOrCode: null,
      designationIdOrCode: null,
      roleIdentifier: "",
      userId: "",
      status: "",
      siteId: "",
    },
    address: {
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      country: "",
      state: "",
      city: "",
      areaCode: "",
      latitude: "",
      longitude: "",
      radius: "",
      timeZone: "",
      isDefault: true,
      addressTypeId: "",
      employeeId: "",
    },
  });

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = useState({
    firstName: "",
    email: "",
    phoneCountryCode: "",
    phone: "",
    code: "",
    status: "",
  });

  const defaultFilter = {
    firstName: "",
    email: "",
    phoneCountryCode: "",
    phone: "",
    code: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpenEditDialog(true);
    setDiaLogBoxBlur(true);
  };

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpenEditDialog(false);
  };

  const [
    inetgrationSetUpForAccessLevel,
    setIntegrationSetUpForAccessLevel,
  ] = useState(false);

  const [
    inetgrationSetUpForCardHolder,
    setIntegrationSetUpForCardHolder,
  ] = useState(false);

  const loadData = (filter, paging) => {
    dispatch(listAllEmployees(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "OMSI0000" && data.data) {
          loadIntegrationSetUp();
          setRows(data.data.employees);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const loadIntegrationSetUp = () => {
    dispatch(getIntegrationStatus())
      .unwrap()
      .then((data) => {
        setIntegrationSetUpForAccessLevel(data.integrationAccessIsEnable);
        setIntegrationSetUpForCardHolder(data.integrationIsEnable);
      });
  };

  const loadEmployeeAssigmentIntegration = async (
    employeeId,
    integrationType,
  ) => {
    const payload = {
      id: employeeId,
      integrationType,
      pageNumber: 1,
      pageSize: 50,
    };

    try {
      const data = await dispatch(
        getEmployeeMappedIntegration(payload),
      ).unwrap();

      return (
        data.code === "MSGS4000" && data.data?.integrationMapping?.length > 0
      );
    } catch (error) {
      return false;
    }
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      firstName: data.firstName,
      email: data.email,
      phoneCountryCode: data.phoneCountryCode,
      phone: data.phone,
      code: data.code,
      status: data.status,
    });
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleDeletePerson = (params) => {
    if (params.row.roleName === "Owner") {
      Toast("Unable to delete Owner", "error");
      return;
    }

    setOpenDeletePerson(true);
    setEmployeeId(params.id);
    setPersonFirstName(params.row.firstName);
    setPersonUserId(params.row.userId);
    setDiaLogBoxBlur(true);
  };

  const handleOpenEditPerson = (params) => {
    setOpenEditDialog(!openEditDialog);
    setSelectedObject(params);
    loadEmployeeRole(params);
    setDiaLogBoxBlur(true);
  };

  const loadEmployeeRole = (payload) => {
    dispatch(getMemberShipByUserId(Object.assign(payload)))
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0000")) {
          setRoleId(data.data.membership[0].roleId);
        } else {
          setRoleId("");
        }
      })
      .catch((er) => {});
  };

  useEffect(() => {
    setRoleId(roleId);
  }, [roleId]);

  const isActive = (params) => {
    if (params.row.status === "INACTIVE") {
      return true;
    }
  };

  const handleResendAccountActivate = (paramValue) => {
    if (paramValue.status === "ACTIVE") {
      Toast(t("EMPLOYEE_ALREADY_ACTIVATED"), "error");
      return;
    }
    dispatch(resendActivationLink(paramValue))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0001") {
          Toast(t("USERSUCCESS"), "success");
        }
      })
      .catch((er) => {});
  };

  const handleDeActivateEmployeeAccount = (rowData) => {
    if (rowData.roleName === "Owner") {
      Toast("Admin can't be deleted!", "error");
      return;
    }

    dispatch(deactivateEmployeeAccount(rowData.id))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0028") {
          Toast("Account deactivated successfully", "success");
          loadData(filter, paging);
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => {});
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 17) + "...";
    } else {
      return text;
    }
  };

  const handleGenetecCardHolder = async (params) => {
    const group = ["GROUP", "ARMATURA_ELEVATOR"];

    const isAssigned = await loadEmployeeAssigmentIntegration(
      params.row.id,
      group,
    );

    if (isAssigned) {
      history.push({
        pathname: REACT_INTEGRATION_LIST,
        state: {
          ...params.row,
          integrationType: group,
        },
      });
    } else {
      history.push({
        pathname: REACT_INTEGRATION_CARD_HOLDER_LIST,
        state: params.row, // only row data
      });
    }
  };

  const handleGenetecAccessLevel = async (params) => {
    const accessLevel = ["ACCESS_LEVEL", "ARMATURA_ACCESS_LEVEL"];
    const isAssigned = await loadEmployeeAssigmentIntegration(
      params.row.id,
      accessLevel,
    );
    if (isAssigned) {
      history.push({
        pathname: REACT_INTEGRATION_LIST,
        state: {
          ...params.row,
          integrationType: accessLevel,
        },
      });
    } else {
      history.push({
        pathname: REACT_INTEGRATION_ACCESS_LEVEL_LIST,
        state: params.row, // only row data
      });
    }
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row;
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };

    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };
  const columns = React.useMemo(
    () => [
      {
        field: "employees.profile",
        headerName: "",
        sortable: false,
        width: 10,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },
      {
        field: "employees.firstName",
        headerName: t("COMMON014"),
        flex: 1,
        minWidth: 120,
        valueGetter: (params) =>
          params.row.firstName +
          " " +
          (params.row.lastName === undefined ? "" : params.row.lastName),
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.firstName +
              " " +
              (params.row.lastName === undefined ? "" : params.row.lastName)}`}
            placement="bottom-start"
          >
            <span>
              {handleTextOverflow(
                params.row.firstName +
                  " " +
                  (params.row.lastName === undefined
                    ? ""
                    : params.row.lastName),
              )}
            </span>
          </Tooltip>
        ),
      },
      {
        field: "employees.code",
        headerName: t("COMMON140"),
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.empCode,
      },
      {
        field: "employees.phone",
        headerName: t("COMMON063"),
        type: "singleSelect",
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.mobile,
      },
      {
        field: "employees.email",
        headerName: t("PERSON005"),
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.email,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.email}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.email)}</span>
          </Tooltip>
        ),
      },
      {
        field: "RoleName",
        headerName: t("Role Name"),
        type: "singleSelect",
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.roleName,
      },

      {
        field: "employees.status",
        headerName: "Status",
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.status,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.status}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.status)}</span>
          </Tooltip>
        ),
      },
      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        minWidth: 205,
        width: 150,
        headerAlign: "center",
        align: "center",
        getActions: (params) => {
          const isUserActive = isActive(params);
          const actions = [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              onClick={() => handleOpenEditPerson(params.row)}
              showInMenu={false}
            />,

            <GridActionsCellItem
              icon={<ResendIcon toolTip={isUserActive} />}
              label="Resend Activation"
              disabled={!isUserActive}
              onClick={() => handleResendAccountActivate(params.row)}
              showInMenu={false}
            />,

            <GridActionsCellItem
              icon={<EmployeeDeleteIcon />}
              label="Delete"
              onClick={() => handleDeletePerson(params)}
              showInMenu={false}
            />,
          ];

          if (inetgrationSetUpForAccessLevel) {
            actions.push(
              <GridActionsCellItem
                key="integration-access-level"
                icon={<GenetecAccessLevlIcon />}
                label="Integration Access Level"
                onClick={() => handleGenetecAccessLevel(params)}
                showInMenu={true}
              />,
            );
          }
          if (inetgrationSetUpForCardHolder) {
            actions.push(
              <GridActionsCellItem
                key="integration-cardholder"
                icon={<GenetecCardHolderIcon />}
                label="Integration Cardholder / Elevator Group"
                onClick={() => handleGenetecCardHolder(params)}
                showInMenu={true}
              />,
            );
          }

          return actions;
        },
      },
    ],
    [inetgrationSetUpForAccessLevel, inetgrationSetUpForCardHolder],
  );

  const handleImport = () => {
    setOpenImportDialog(true);
    setDiaLogBoxBlur(true);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar title={t("PERSON0111")} tooltipTitle={t("COMMON141")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "1",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("PERSON0111")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Tooltip title={t("VISACCLEVEL003")}>
          <Box
            item
            className={darkMode ? "importdark" : "import"}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleImport}
          >
            {isHovered ? (
              <ImportHover style={{ color: darkMode ? "#fff" : "#474a4e" }} />
            ) : (
              <ImportIcon style={{ color: darkMode ? "#fff" : "#474a4e" }} />
            )}
          </Box>
        </Tooltip>
        <Box item>
          <EmployeeFilter
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>
      </Box>
      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={searchedRows.length === 0 ? rows : searchedRows}
          page={page}
          pageCount={totalPages}
          count={totalRecords}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {openEditDialog && (
        <CreateEmployee
          selectedObject={selectedObject}
          open={openEditDialog}
          roleId={roleId}
          onClose={() => {
            setOpenEditDialog(false);
            loadData(filter, paging);
            setRoleId("");
            setDiaLogBoxBlur(false);
          }}
        />
      )}
      {openEditDialog && (
        <CreateEmployee
          selectedObject={selectedObject}
          roleId={roleId}
          open={openEditDialog}
          handleClose={() => {
            setOpenEditDialog(false);
            loadData(filter, paging);
            setRoleId("");
            setDiaLogBoxBlur(false);
            setSelectedObject({
              employee: {
                id: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                gender: "",
                profilePhoto: "",
                departmentId: "",
                designationId: "",
                code: "",
                departmentIdOrCode: null,
                designationIdOrCode: null,
                roleIdentifier: "",
                userId: "",
                status: "",
                siteId: "",
              },
              address: {
                addressLine1: "",
                addressLine2: "",
                addressLine3: "",
                country: "",
                state: "",
                city: "",
                areaCode: "",
                latitude: "",
                longitude: "",
                radius: "",
                timeZone: "",
                isDefault: true,
                addressTypeId: "",
                employeeId: "",
              },
            });
          }}
        />
      )}
      {openDeletePerson && (
        <DeleteEmployee
          open={openDeletePerson}
          handleClose={(data) => {
            setOpenDeletePerson(data);
            setDiaLogBoxBlur(false);
          }}
          DeleteId={employeeId}
          DeleteFirstName={personFirstName}
          DeleteUserId={personUserId}
          delete={() => setDel(true)}
        />
      )}
      {openImportDialog && (
        <BulkEmployee
          open={openImportDialog}
          handleClose={() => {
            setOpenImportDialog(false);
            loadData(filter, paging);
            setDiaLogBoxBlur(false);
          }}
        />
      )}
    </>
  );
}
